export { default } from './PromoHeader';
